import { IntlShape } from '@redbubble/next/intl';
import { DeviceType } from '@redbubble/next/types';
import { ChangeResolveDetails, StripeElements } from '@stripe/stripe-js';
import { fromCart as toLineItems } from '../lineItems';
import { fromCart as toShippingRates } from '../shippingRates';
import { StripeCart } from '../types';
import { getSubunitAmount } from '../utils';

export const updateModalAfterCartRefetch = (
  cart: StripeCart,
  elements: StripeElements,
  resolve: (resolveDetails?: ChangeResolveDetails) => void,
  intl: IntlShape,
  isOrAbove: (deviceType: DeviceType) => boolean
) => {
  const lineItems = toLineItems(cart, intl, isOrAbove);
  const shippingRates = toShippingRates(cart, intl);

  const amount = getSubunitAmount(cart.summary.total);
  if (amount === 0) {
    // A $0 amount will see the StripeExpress component no longer
    // rendering the Stripe Elements components. This should be
    // fast enough to hide the error showing in the modal as a result
    // of calling resolve() here.
    // This only works for Google Pay. The Apple Pay modal does
    // not auto-close, so the customer has to do it :( They can
    // continue just fine with a $0 checkout at that point.
    // GitHub issue raised - https://github.com/stripe/react-stripe-js/issues/445
    resolve();
    return;
  }

  elements.update({ amount });

  resolve({
    lineItems,
    shippingRates,
  });
};
